import { BookingState } from './book/book.reducer';
import { bookReducer } from './book/book.reducer';
import { BookEffects } from './book/book.effects';

import { UserState } from './user/user.reducer';
import { userReducer } from './user/user.reducer';
import { UserEffects } from './user/user.effects';

export const storeReducers = {
  booking: bookReducer,
  user: userReducer,
};

export const storeEffects = [BookEffects, UserEffects];

export interface AppState {
  book: BookingState;
  user: UserState;
}
